import { Component, inject, Input } from '@angular/core';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { CountBoxComponent } from '../../atoms/count-box/count-box.component';

@Component({
  selector: 'app-count-box-data',
  standalone: true,
  imports: [CountBoxComponent],
  templateUrl: './count-box-data.component.html',
  styleUrl: './count-box-data.component.scss',
})
export class CountBoxDataComponent {
  readonly store = inject(IndicatorDataStore);
  @Input() title = 'Daten';
  @Input() text = '';
  @Input() styleClass = '';
}
